<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="expert2.id && expert2.id > 0">{{$t('expert2.edit.title')}}</h4>
                                    <h4 class="card-title float-left" v-else>{{$t('expert2.add.title')}}</h4>
                                </div>
                                <div class="pull-right d-flex">
                                    <button class="all-btn add-btn" @click="save" v-if="canSave" :disabled="processing">
                                        <i class="fa fa-save"></i>
                                        {{$t("action.save")}}
                                    </button>
                                    <button class="all-btn delete-btn ml-3" @click="cancel" v-if="objectType !== 'Asset'" :disabled="processing">{{$t("action.cancel")}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-5">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-12 mb-3" style="border-bottom: 1px solid #eee;">
                                            <div class="form-check form-check-radio checkbox-inline pl-0"
                                                 style="margin-left:-0.8rem">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="docType"
                                                           value="cadastre" v-model="docType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("expert2.field.docCadastre")}}
                                                </label>
                                            </div>
                                            <div class="form-check form-check-radio checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="docType"
                                                           value="report" v-model="docType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("expert2.field.docReport")}}
                                                </label>
                                            </div>
                                            <div class="form-check form-check-radio checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="docType"
                                                           value="photos" v-model="docType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("expert2.field.docPhotos")}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <carousel :perPage="1"
                                                      style="border: 1px solid #eee;"
                                                      :navigationEnabled="true"
                                                      :navigationNextLabel="next"
                                                      :navigationPrevLabel="prev">
                                                <slide v-for="(photo) in expert2Parent[docType]" v-bind:key="photo.id">
                                                    <div v-if="photo && photo.type !== 'application/pdf'">
                                                        <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                                                        <inner-image-zoom :src="photo.filePath"
                                                                          :style="rotateStyle"
                                                        ></inner-image-zoom>
                                                    </div>
                                                    <div v-else-if="photo && photo.type === 'application/pdf'">
                                                        <iframe :src="photo.filePath" width="100%" style="height: 600px"></iframe>
                                                    </div>
                                                </slide>
                                            </carousel>
                                            <div class="text-center mt-3 d-flex justify-content-center align-items-center mb-3">
                                                <button class="all-btn add-btn mr-3" @click="rotateRight">
                                                    <i class="fa fa-mail-reply"></i>
                                                </button>
                                                <button class="all-btn add-btn" @click="rotateLeft">
                                                    <i class="fa fa-mail-forward"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-7 card-wrap">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*</span></label>
                                            <cadastre-input :cadastre-number.sync="expert2.cadastreDocNumber" :invalid="$v.expert2.cadastreDocNumber.$error"/>
                                        </div>
                                        <div class="red" v-if="$v.expert2.cadastreDocNumber.$error">
                                            {{$t("realEstate.validation.cadastreNumber")}}
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.areaTotal")}} <span class="red"> *</span></label>
                                            <numeric-input v-model="expert2.totalGroundArea" :precision="2" :class="{invalid: $v.expert2.totalGroundArea.$error}"></numeric-input>
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t("realEstate.field.areaUseful")}} <span class="red"> *</span></label>
                                            <numeric-input v-model="expert2.usefulArea" :precision="2" :class="{invalid: $v.expert2.usefulArea.$error}"></numeric-input>
                                        </div>
                                        <div class="form-group">
                                          <label>{{$t("realEstate.field.evlTotalArea")}} <span class="red"> *</span></label>
                                          <numeric-input v-model="expert2.totalArea" :precision="2" :class="{invalid: $v.expert2.totalArea.$error}"></numeric-input>
                                        </div>
                                        <div class="form-group">
                                          <div class="form-check pl-0">
                                            <label class="form-check-label text-uppercase" style="padding-left:22px !important">
                                              <input class="form-check-input" type="checkbox"
                                                     v-model="expert2.hasTotalArea">
                                              <span class="form-check-sign"></span>
                                              {{$t("realEstate.field.hasTotalArea")}}
                                            </label>
                                          </div>
                                        </div>
                                        <div class="form-group">
                                            <label>{{$t("expert2.field.buildingCount")}} <span class="red">*</span></label>
                                            <numeric-input :precision="0" v-model="expert2.buildingCount" :class="{invalid: $v.expert2.buildingCount.$error}"></numeric-input>
                                        </div>
                                        <div class="card mb-3" style="border-radius: 0;" v-if="expert2.methods">
                                            <div class="card-header text-left" style="background-color: #b3e6cc; border-radius: 0; font-weight: bold">
                                                <span>{{expert2.methods.fieldName}}</span>
                                            </div>
                                            <div class="card-body">
                                                <div class="table-wrapper">
                                                    <table class="table table-striped">
                                                        <tbody v-if="expert2.methods.experts && expert2.methods.experts.length > 0">
                                                        <tr v-for="(expert, index) in expert2.methods.experts" :key="expert.refCode" class="d-flex flex-wrap align-items-center border-bottom">
                                                            <td width="35%">
                                                                <div class="form-check pull-left">
                                                                    <label class="form-check-label">
                                                                        <input class="form-check-input" type="checkbox" v-model="expert.accept" @change="onChangeAccept(expert)">
                                                                        <span class="form-check-sign"></span>
                                                                    </label>
                                                                </div>
                                                                <span style="font-size: 14px;">{{expert.refCode}} :</span>
                                                                <span style="font-size: 14px;">{{expert.refName}}</span>
                                                            </td>
                                                            <td width="65%" class="border-0">
                                                                <select class="form-control"
                                                                        v-model="expert.condition"
                                                                        :class="{invalid: $v.expert2.methods.experts.$each[index].condition.$error}"
                                                                        :disabled="!expert.accept"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="COMPLETED">бажарилган</option>
                                                                    <option value="NOT_COMPLETED">бажарилмаган</option>
                                                                </select>
                                                            </td>
                                                            <td v-if="expert.condition!=='COMPLETED' && expert.accept" width="100%">
                                                              <expert2-comment-edit :expert.sync="expert" :references="references" :method="'Methods'"></expert2-comment-edit>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <div :class="{invalid : $v.approach.$error}">
                                            <div class="form-check pl-0 checkbox-inline">
                                                <label class="form-check-label"
                                                       style="padding-left:22px !important">
                                                    <input class="form-check-input" type="checkbox"
                                                           v-model="expert2.approachCost"
                                                           @change="onCalculateCoordination"
                                                    >
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.approach.expense")}}
                                                </label>
                                            </div>
                                            <div class="form-check checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="checkbox"
                                                           v-model="expert2.approachComparative"
                                                           @change="onCalculateCoordination"
                                                    >
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.approach.comparative")}}
                                                </label>
                                            </div>
                                            <div class="form-check checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="checkbox"
                                                           v-model="expert2.approachIncome"
                                                           @change="onCalculateCoordination"
                                                    >
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.approach.income")}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="card mb-3">
                                            <b-tabs card
                                                    active-nav-item-class="font-weight-bold text-uppercase"
                                                    active-tab-class="font-weight-bold text-success"
                                            >
                                                <b-tab title="Харажат ёндашув" active v-if="expert2.approachCost" :title-link-class="{red: $v.expert2.expertExpense.$error}" @click="onSaveApproach">
                                                    <template v-if="expert2.expertExpense">
                                                        <div class="table-wrapper">
                                                            <table class="table table-striped">
                                                                <tbody v-if="expert2.expertExpense.experts && expert2.expertExpense.experts.length > 0">
                                                                <tr v-for="(expert, index) in expert2.expertExpense.experts" :key="expert.refCode" class="d-flex flex-wrap align-items-center border-bottom">
                                                                    <td width="35%" class="border-0">
                                                                        <div class="form-check pull-left">
                                                                            <label class="form-check-label">
                                                                                <input class="form-check-input" type="checkbox" v-model="expert.accept" @change="onChangeAccept(expert)">
                                                                                <span class="form-check-sign"></span>
                                                                            </label>
                                                                        </div>
                                                                        <span style="font-size: 14px;">{{expert.refCode}} :</span>
                                                                        <span style="font-size: 14px;">{{expert.refName}}</span>
                                                                    </td>
                                                                    <td width="65%" class="border-0">
                                                                        <select class="form-control"
                                                                                v-model="expert.condition"
                                                                                :class="{invalid: $v.expert2.expertExpense.experts.$each[index].condition.$error}"
                                                                                :disabled="!expert.accept"
                                                                        >
                                                                            <option value=""></option>
                                                                            <option value="COMPLETED">бажарилган</option>
                                                                            <option value="NOT_COMPLETED">бажарилмаган</option>
                                                                        </select>
                                                                    </td>
                                                                    <td v-if="expert.condition!=='COMPLETED' && expert.accept" width="100%">
                                                                      <expert2-comment-edit :expert.sync="expert" :references="references" :method="'ExpertExpense'"></expert2-comment-edit>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </template>
                                                </b-tab>
                                                <b-tab title="Қиёсий ёндашув" v-if="expert2.approachComparative" :title-link-class="{red: $v.expert2.expertComparative.$error}" @click="onSaveApproach">
                                                    <template v-if="expert2.expertComparative">
                                                        <div class="table-wrapper">
                                                            <table class="table table-striped">
                                                                <tbody v-if="expert2.expertComparative.experts && expert2.expertComparative.experts.length > 0">
                                                                <tr v-for="(expert, index) in expert2.expertComparative.experts" :key="expert.refCode" class="d-flex flex-wrap align-items-center border-bottom">
                                                                    <td width="35%" class="border-0">
                                                                        <div class="form-check pull-left">
                                                                            <label class="form-check-label">
                                                                                <input class="form-check-input" type="checkbox" v-model="expert.accept" @change="onChangeAccept(expert)">
                                                                                <span class="form-check-sign"></span>
                                                                            </label>
                                                                        </div>
                                                                        <span style="font-size: 14px;">{{expert.refCode}} :</span>
                                                                        <span style="font-size: 14px;">{{expert.refName}}</span>
                                                                    </td>
                                                                    <td width="65%" class="border-0">
                                                                        <select class="form-control"
                                                                                v-model="expert.condition"
                                                                                :class="{invalid: $v.expert2.expertComparative.experts.$each[index].condition.$error}"
                                                                                :disabled="!expert.accept"
                                                                        >
                                                                            <option value=""></option>
                                                                            <option value="COMPLETED">бажарилган</option>
                                                                            <option value="NOT_COMPLETED">бажарилмаган</option>
                                                                        </select>
                                                                    </td>
                                                                    <td v-if="expert.condition!=='COMPLETED' && expert.accept" width="100%">
                                                                      <expert2-comment-edit :expert.sync="expert" :references="references" :method="'ExpertComparative'"></expert2-comment-edit>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </template>
                                                </b-tab>
                                                <b-tab title="Даромад ёндашув" v-if="expert2.approachIncome" :title-link-class="{red: $v.expert2.expertIncome.$error}" @click="onSaveApproach">
                                                    <template v-if="expert2.expertIncome">
                                                        <div class="table-wrapper">
                                                            <table class="table table-striped">
                                                                <tbody v-if="expert2.expertIncome.experts && expert2.expertIncome.experts.length > 0">
                                                                <tr v-for="(expert, index) in expert2.expertIncome.experts" :key="expert.refCode" class="d-flex flex-wrap align-items-center border-bottom">
                                                                    <td width="35%" class="border-0">
                                                                        <div class="form-check pull-left">
                                                                            <label class="form-check-label">
                                                                                <input class="form-check-input" type="checkbox" v-model="expert.accept" @change="onChangeAccept(expert)">
                                                                                <span class="form-check-sign"></span>
                                                                            </label>
                                                                        </div>
                                                                        <span style="font-size: 14px;">{{expert.refCode}} :</span>
                                                                        <span style="font-size: 14px;">{{expert.refName}}</span>
                                                                    </td>
                                                                    <td width="65%" class="border-0">
                                                                        <select class="form-control"
                                                                                v-model="expert.condition"
                                                                                :class="{invalid: $v.expert2.expertIncome.experts.$each[index].condition.$error}"
                                                                                :disabled="!expert.accept"
                                                                        >
                                                                            <option value=""></option>
                                                                            <option value="COMPLETED">бажарилган</option>
                                                                            <option value="NOT_COMPLETED">бажарилмаган</option>
                                                                        </select>
                                                                    </td>
                                                                    <td v-if="expert.condition!=='COMPLETED' && expert.accept" width="100%">
                                                                      <expert2-comment-edit :expert.sync="expert" :references="references" :method="'ExpertIncome'"></expert2-comment-edit>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </template>
                                                </b-tab>
                                            </b-tabs>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="card mb-3" v-if="expert2.expertCoordination">
                                            <div class="card-header text-center" style="background-color: #b3e6cc; font-weight: bold">
                                                <span>{{expert2.expertCoordination.fieldName}}</span>
                                            </div>
                                            <div class="card-body">
                                                <div class="table-wrapper">
                                                    <table class="table table-striped">
                                                        <tbody v-if="expert2.expertCoordination.experts && expert2.expertCoordination.experts.length > 0">
                                                        <tr v-for="(expert, index) in expert2.expertCoordination.experts" :key="expert.refCode" class="d-flex flex-wrap align-items-center border-bottom">
                                                            <td width="35%">
                                                                <div class="form-check pull-left">
                                                                    <label class="form-check-label">
                                                                        <input class="form-check-input" type="checkbox" v-model="expert.accept" @change="onChangeAccept(expert)">
                                                                        <span class="form-check-sign"></span>
                                                                    </label>
                                                                </div>
                                                                <span style="font-size: 14px;">{{expert.refCode}} :</span>
                                                                <span style="font-size: 14px;">{{expert.refName}}</span>
                                                            </td>
                                                            <td width="65%" class="border-0">
                                                                <select class="form-control"
                                                                        v-model="expert.condition"
                                                                        :class="{invalid: $v.expert2.expertCoordination.experts.$each[index].condition.$error}"
                                                                        :disabled="!expert.accept"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="COMPLETED">бажарилган</option>
                                                                    <option value="NOT_COMPLETED">бажарилмаган</option>
                                                                </select>
                                                            </td>
                                                            <td v-if="expert.condition!=='COMPLETED' && expert.accept" width="100%">
                                                              <expert2-comment-edit :expert.sync="expert" :references="references" :method="'ExpertCoordination'"></expert2-comment-edit>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="expert2 && expert2.calculated && expert2.coordination">
                                        <div class="col-12 mt-3">
                                            <div class="card">
                                                <div class="card-header text-center" style="background-color: #b3e6cc; font-weight: bold">
                                                    <span>{{$t('expert2.calculated.expense')}}</span>
                                                </div>
                                                <div class="card-body">
                                                    <div class="form-group">
                                                      <label>Ер учаскасидан фойдаланиш хукуки киймати <span class="red">*</span></label>
                                                      <numeric-input class="form-control"
                                                                     v-model="expert2.calculated.landAmount"
                                                                     :controls="false" :precision="2"
                                                                     :class="{invalid: $v.expert2.calculated.landAmount.$error}"
                                                      ></numeric-input>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Жами кучмас мулк киймати <span class="red">*</span></label>
                                                        <numeric-input v-model="expert2.coordination.total"
                                                                       type="text" class="form-control"
                                                                       :precision="2"
                                                                       :class="{invalid: $v.expert2.coordination.total.$error}"
                                                        ></numeric-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-3">
                                <button class="all-btn add-btn pull-right"
                                        v-if="(hasPermission('EXPERT2_ASSET_EDIT') || hasPermission('EXPERT2_EDIT')) && (expert2.id && expert2.id > 0)"
                                        @click="addRealEstate"
                                             >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('action.add')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BTabs } from 'bootstrap-vue'
    import {BTab} from 'bootstrap-vue'
    import {required,requiredUnless,minValue} from 'vuelidate/lib/validators';
    import {Carousel, Slide} from 'vue-carousel';
    import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
    import InnerImageZoom from 'vue-inner-image-zoom';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import initFilterModel from '@/shared/filter';
    import {TheMask} from 'vue-the-mask';
    import CadastreInput from "@/components/CadastreInput.vue";
    import {cadastreNumber} from "@/shared/validator-helpers";
    import Expert2CommentEdit from "@/views/expert2/Expert2CommentEdit.vue";

    export default {
        components: {
          CadastreInput,
            BTabs,
            BTab,
            Carousel,
            Slide,
            'inner-image-zoom': InnerImageZoom,
            TheMask,
            Expert2CommentEdit
        },
        data() {
            return {
                processing: false,
                prev: '<i class="material-icons">keyboard_arrow_left</i>',
                next: '<i class="material-icons">keyboard_arrow_right</i>',
                filter: initFilterModel(),
                objectType: (this.$route.query.hasOwnProperty('objectType') && this.$route.query.objectType) ? this.$route.query.objectType : null,
                expert2: {
                    id: null,
                    expert2Id: ((this.$route.params.hasOwnProperty('expert2Id') && this.$route.params.expert2Id) ? this.$route.params.expert2Id : null),
                    evlObjectType: 'Building',
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    methods: {},
                    expertExpense: {},
                    expertComparative: {},
                    expertIncome: {},
                    expertCoordination: {},
                    calculated: null,
                    coordination: {},
                    buildingCount: 0,
                    totalGroundArea: 0,
                    usefulArea: 0,
                    cadastreDocNumber: '',
                    totalArea: 0,
                    hasTotalArea: false
                },
                references: {},
                expert2Fields: [],
                docType: 'photos',
                expert2Parent: {},
                minValueUsefulArea: 0.01,
                minValueTotalArea: 0
            }
        },
        validations() {
            return {
                expert2: {
                    methods: {
                        experts: {
                            required,
                            $each: {
                                condition: {
                                    required: requiredUnless(vm => {
                                        return !(vm.accept)
                                    })
                                }
                            }
                        }
                    },
                    expertExpense: {
                        experts: {
                            required,
                            $each: {
                                condition: {
                                    required: requiredUnless((vm) => {
                                        return !(this.expert2.approachCost && vm.accept)
                                    })
                                }
                            }
                        }
                    },
                    expertComparative: {
                        experts: {
                            required,
                            $each: {
                                condition: {
                                    required: requiredUnless((vm) => {
                                        return !(this.expert2.approachComparative && vm.accept)
                                    })
                                }
                            }
                        }
                    },
                    expertIncome: {
                        experts: {
                            required,
                            $each: {
                                condition: {
                                    required: requiredUnless((vm) => {
                                        return !(this.expert2.approachIncome && vm.accept)
                                    })
                                }
                            }
                        }
                    },
                    expertCoordination: {
                        experts: {
                            required,
                            $each: {
                                condition: {
                                    required: requiredUnless(vm => {
                                        return !(vm.accept)
                                    })
                                }
                            }
                        }
                    },
                    calculated: {
                        landAmount: {
                            required: required
                        }
                    },
                    coordination: {
                      total: {
                        required: required
                      }
                    },
                    cadastreDocNumber: {
                        required: required,
                        cadastreNumber: cadastreNumber
                    },
                    buildingCount: {
                        required: required,
                        minValue: minValue(1)
                    },
                    totalGroundArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    usefulArea: {
                        required: required,
                        minValue: minValue(this.minValueUsefulArea)
                    },
                    totalArea: {
                      required: requiredUnless(() => {
                        return !this.expert2.hasTotalArea
                      }),
                      minValue: minValue(this.minValueTotalArea)
                    }
                },
                approach: {
                    required: requiredUnless(() => {
                        return !(!(this.expert2.approachCost || this.expert2.approachComparative || this.expert2.approachIncome));
                    })
                }
            }
        },
        computed: {
            rotateStyle() {
                return { transform: 'rotate(' + this.turn + 'turn)'}
            },
            canSave() {
                return (this.expert2Parent.status === 'Pending' || this.expert2Parent.status === 'AssignedToEvaluator' || this.expert2Parent.status === 'NotFullyEvaluated');
            },
            hasTotalArea() {
              return this.expert2.hasTotalArea
            }
        },
        methods: {
            emptyExpert(ref) {
              return {
                refId: ref.id,
                refCode: ref.code,
                condition: null,
                comment: '',
                refName: ref.name,
                accept: false,
                comments: [],
                selected:[],
              }
            },
            hasField(condition) {
                return condition !== 'COMPLETED';
            },
            onChangeAccept(expert) {
              expert.condition = expert.accept ? "NOT_COMPLETED" :  null
            },
            getExpert(field, expertData) {
                let experts = [];
                const reference = this.getReferences(field.code);
                reference.forEach((ref) => {
                    let expert = {};
                    if (expertData && expertData.experts) {
                      expert = expertData.experts.find(e => e.refCode === ref.code)
                      expert.selected = expert && expert.comments ? expert.comments.map(item => item.id ? item.id : item.code) : []
                    } else {
                      expert = this.emptyExpert(ref);
                    }

                    const childFields = ref.data && ref.data.childFields ? ref.data.childFields : [];
                    childFields.forEach((childField) => {
                      if (childField.code === 'COMMENTS' || childField.code === 'COMMENT') {
                        if (childField.type === 'LISTBOX' || childField.type === 'MULTISELECT') {
                          expert[childField.code] = childField.options.map(option => {
                            if (option.childCode) {
                              const childFieldData = childFields.find(cf => cf.code === option.childCode);
                              return {
                                ...option,
                                id: option.code,
                                children: childFieldData ? childFieldData.options.map(child => ({...child, id:`${option.code}__${child.code}`, parent: {name: option.name, code: option.code}})) : []
                              };
                            }
                            return {...option, id: option.code};
                          });
                        }
                      }
                    });

                    experts.push(expert);
                });

                expertData.experts = experts;
                expertData.fieldCode = field.code;
                expertData.fieldId = field.id;
                expertData.fieldName = field.name;

                return expertData;
            },
            init() {
                const vm = this;
                const id = this.$route.params.id;

                this.filter.targetType = 'Building';
                const promises = [
                    this.$http.post('/admin/expert2/init', this.filter)
                ];

                if (id && id > 0) {
                    promises.push(this.$http.get(`/admin/expert2/item/${id}`))
                } else {
                    promises.push(this.$http.get(`/admin/expert2/${vm.expert2.expert2Id}/item/init`))
                }

                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;

                    vm.references = initData.references;
                    vm.expert2Fields = initData.fields;

                    if (values.length >= 2) {

                        const editData = values[1].data;
                        vm.expert2Parent = editData.expert2;

                        vm.expert2Fields.forEach((field) => {
                            if (field.code === 'Methods') {
                                editData.methods = editData.methods || {};
                                editData.methods = vm.getExpert(field,editData.methods);
                            }

                            if (field.code === 'ExpertExpense') {
                                editData.expertExpense = editData.expertExpense || {};
                                editData.expertExpense = vm.getExpert(field,editData.expertExpense);
                            }

                            if (field.code === 'ExpertComparative') {
                                editData.expertComparative = editData.expertComparative || {};
                                editData.expertComparative = vm.getExpert(field,editData.expertComparative);
                            }

                            if (field.code === 'ExpertIncome') {
                                editData.expertIncome = editData.expertIncome || {};
                                editData.expertIncome = vm.getExpert(field,editData.expertIncome);
                            }

                            if (field.code === 'ExpertCoordination') {
                                editData.expertCoordination = editData.expertCoordination || {};
                                editData.expertCoordination = vm.getExpert(field,editData.expertCoordination);
                            }
                        });

                        if (!editData.calculated) {
                            editData.calculated = {}
                        }

                        if (!editData.evlObjectType) {
                            editData.evlObjectType = 'Building'
                        }

                        vm.expert2 = editData;
                    }
                })
            },
            cancel() {
                const id = this.$route.params.expert2Id;
                const hasEdit = this.$route.query.hasEdit;
                const objectType = this.$route.query.objectType;

                if (hasEdit && objectType !== 'Asset') {
                    this.$router.push(`/expert2/real-estate/edit/${id}`)
                } else {
                    this.$router.push('/expert2/list')
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                this.$http.post(`admin/save/expert2/item/requirement/${this.expert2.expert2Id}`, this.expert2)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.expert2.statusSuccess'),
                                type: 'success'
                            });
                            // this.cancel()
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            getReferences(code) {
                if (code && this.references.hasOwnProperty(code)) {
                    const fieldReferences = this.references[code];
                    return fieldReferences.length > 0 ? fieldReferences: []
                } else {
                    return [];
                }
            },
            rotateRight() {
                this.turn = this.turn - 0.25
            },
            rotateLeft() {
                this.turn = this.turn + 0.25
            },
            onCalculateCoordination() {
                const coordination = this.expert2.coordination;

                coordination.expense.total = this.expert2.approachCost ? (this.expert2.coordination.expense.amount * this.expert2.coordination.expense.factorAverage) : 0;
                coordination.comparison.total =  this.expert2.approachComparative ? (this.expert2.coordination.comparison.amount * this.expert2.coordination.comparison.factorAverage) : 0;
                coordination.income.total =  this.expert2.approachIncome ? (this.expert2.coordination.income.amount * this.expert2.coordination.income.factorAverage) : 0;

                coordination.total = coordination.expense.total + coordination.comparison.total + coordination.income.total;
                this.expert2.coordination = coordination;
            },
            onSaveApproach() {

                let expert2 = this.expert2;

                const approachRequest = {
                    approachCost: expert2.approachCost,
                    approachIncome: expert2.approachIncome,
                    approachComparative: expert2.approachComparative,
                    evlObjectType: 'Building',
                    methods: null,
                    expertExpense: null,
                    expertComparative: null,
                    expertIncome: null,
                    expertCoordination: null,
                    calculated: null,
                    coordination: null,
                    buildingCount: expert2.buildingCount,
                    totalGroundArea: expert2.totalGroundArea,
                    usefulArea: expert2.usefulArea,
                    cadastreDocNumber: expert2.cadastreDocNumber
                }

                this.$v.expert2.methods.$touch()
                this.$v.expert2.expertExpense.$touch()
                this.$v.expert2.expertComparative.$touch()
                this.$v.expert2.expertIncome.$touch()
                this.$v.expert2.expertCoordination.$touch()
                this.$v.expert2.coordination.$touch()

                const isMethods = this.$v.expert2.methods.$invalid
                const isExpertCoordination = this.$v.expert2.expertCoordination.$invalid
                const isCoordination = this.$v.expert2.coordination.$invalid
                const isValidExpense = this.$v.expert2.expertExpense.$invalid
                const isValidComparative = this.$v.expert2.expertComparative.$invalid
                const isValidIncome = this.$v.expert2.expertIncome.$invalid

                if (!isMethods) {
                    approachRequest.methods = this.expert2.methods;
                }

                if (!isValidExpense && approachRequest.approachCost) {
                    approachRequest.expertExpense = this.expert2.expertExpense;
                }

                if (!isValidComparative && approachRequest.approachComparative) {
                    approachRequest.expertComparative = this.expert2.expertComparative;
                }

                if (!isValidIncome && approachRequest.approachIncome) {
                    approachRequest.expertIncome = this.expert2.expertIncome;
                }

                if (!isExpertCoordination) {
                    approachRequest.expertCoordination = this.expert2.expertCoordination;
                }

                if (!isCoordination) {
                    approachRequest.coordination = this.expert2.coordination;
                }

                approachRequest.calculated = this.expert2.calculated;

                if (isMethods || isValidExpense || isValidComparative || isValidIncome || !this.canSave) {
                    return;
                }

                this.processing = true;

                this.$http.post(`admin/save/expert2/item/requirement/${this.expert2.expert2Id}`, approachRequest)
                    .then(res => {
                        if (res && res.data && res.data.status !== 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.expert2.error'),
                                type: 'error'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
          addRealEstate() {
            if (this.objectType === 'Asset') {
              this.$router.push({
                path: `/expert2/asset/${this.expert2.expert2Id}/real-estate/requirement/new`,
                query: {hasEdit: true, objectType: this.objectType}
              })
            } else if (this.objectType === 'Building') {
              this.$router.push({
                path: `/expert2/${this.expert2.expert2Id}/real-estate/requirement/new`,
                query: {hasEdit: true, objectType: this.objectType}
              })
            }
          }
        },
        created() {
            this.init()
        },
        watch: {
          hasTotalArea : {
            handler: function (val) {
              if (val) {
                this.minValueTotalArea = 0.01
                this.minValueUsefulArea = 0
              } else {
                this.minValueTotalArea = 0
                this.minValueUsefulArea = 0.01
              }
            }
          }
        }
    }
</script>

<style scoped>
    .card-wrap {
        overflow-y: scroll;
        max-height: 72vh;
    }

    .card {
        border-radius: 0;
    }

    .card .card-header {
        border-radius: 0;
        font-size: 14px;
    }

    .comparison-table {
        font-size: 14px;
    }
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #b3e6cc;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }

</style>